// extracted by mini-css-extract-plugin
module.exports = {"addressMetaInfo":"AddressMetaInfo_addressMetaInfo__3Jl1N","header":"AddressMetaInfo_header__14rrG","address":"AddressMetaInfo_address__1wuQL"};